import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { EE123PeopleRole_Edit, EE123SalariesRole_Edit } from "../../../Component/Common/Constants/UserRoles";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { userRolesState } from "../../../State/user.Atom";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { Grid, Tab, Tabs } from "@mui/material";
import { DataImportType } from "../../../Component/Model/Enum/BEE123Enums";
import { GroupImport } from "./GroupImport";
import { eeModule } from "../../../Component/Common/Constants/routes";
import { useEffect } from "react";
import { EEScorecardAtom } from "../../../State/EEScorecard.Atom";
import { ConsolidationAtom } from "../../../State/Consolidation.Atom";
import {ScorecardAtom} from "../../../State/Scorecard.Atom";
import {WSPScorecardAtom} from "../../../State/WSPScorecard.Atom";
import {ClientRegistrationAtom} from "../../../State/Advisory/ClientRegistration.Atom";
import {OrganisationAtom} from "../../../State/Organisation.Atom";
import {BBBEEScorecardAtom} from "../../../State/BBBEEScorecard.Atom";
import { GroupImportsPeopleSection, GroupImportsSalariesSection } from "../../../Component/Common/Constants/UserActivityTrackingSections";

export const GroupImportsBase = () => {
    const routes = [
        `/${eeModule.ee}/${eeModule.groupImports}/People`,
        `/${eeModule.ee}/${eeModule.groupImports}/Salaries`
    ]

    const resetScorecard = useResetRecoilState(ScorecardAtom);
    const resetScorecardData = useResetRecoilState(EEScorecardAtom);
    const resetScorecardType = useResetRecoilState(ConsolidationAtom);
    const resetWSPScorecard = useResetRecoilState(WSPScorecardAtom);
    const resetClientRegistration = useResetRecoilState(ClientRegistrationAtom);
    const resetOrganisation = useResetRecoilState(OrganisationAtom);
    const resetBBBEEScorecard = useResetRecoilState(BBBEEScorecardAtom);
    const userRoles = useRecoilValue(userRolesState);
    const routeMatch = useRouteMatch(routes);
    let currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };
    
    useEffect(() => {
        resetScorecard();
        resetScorecardData();
        resetScorecardType();
        resetWSPScorecard();
        resetClientRegistration();
        resetOrganisation()
        resetBBBEEScorecard();
    });

    return (
        <>
            <MDTypography variant="h4" style={{ paddingBottom: "20px" }}>EE Module - Group Imports</MDTypography>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        {userRoles.includes(EE123PeopleRole_Edit) &&
                            <Tab label="People" value={routes[0]} to={routes[0]} component={Link} />}
                        {userRoles.includes(EE123SalariesRole_Edit) &&
                            <Tab label="Salaries" value={routes[1]} to={routes[1]} component={Link} />}
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <GroupImport dataImportType={DataImportType.Individual} key={DataImportType.Individual} section={GroupImportsPeopleSection}/>
                        </Route>
                        <Route path={routes[1]}>
                            <GroupImport dataImportType={DataImportType.EESalary} key={DataImportType.EESalary} section={GroupImportsSalariesSection}/>
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    );
}